import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'military-information',
    templateUrl: './military-information.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class MilitaryInformationComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.MilitaryInformationVM = {} as models.MilitaryInformationVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  isPublicLinkFieldInvalid(): boolean {
    return this.cardData.hadMandatoryService && this.cardData.hadMandatoryService.toString() == 'true' && !this.cardData.lostPublicLink;
  }
}
